/* eslint-disable quotes */
import { defineComponent, h, PropType } from "vue";
import { Button, Dialog } from '@phi/components';
import { Length } from '../../Units';
import { set_grid_size_and_adjust_grid } from '@frontend/scene';
import { Flex } from '@phi/components/layout';

const centered = `<div class="row">
    <div class="col-sm-12 block-3-box">
        <div class="scale-options">
            <label for="gridCenteredAtVertex" class="label label--with-checkbox">
                <input class="form-control sr-only" type="checkbox" name="gridCenteredAtVertex"
                    id="gridCenteredAtVertex">
                <div class="phi-custom-checkbox">
                    <svg class="phi-custom-checkbox__icon" width="16" height="16">
                        <use xlink:href="#arrow-check"></use>
                    </svg>
                </div>
                <div class="label__text">Center grid at selected vertex</div>
            </label>
        </div>
    </div>
</div>`;

export default defineComponent({
    props: {
        units: {
            required: true,
            type: String as PropType<Length>
        },

        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    setup(props, { emit }) {
        return () => h(Dialog, {
            show: props.show,
            'onUpdate:show': x => emit('update:show', x),
            onClose: () => emit('update:show', false),
            id: 'setGridsizeModal',
            title: `Set grid line spacing (in ${props.units})`,
            unload: false,
            width: 'narrower',
            confirm_label: null,
        }, () => [
            h(Flex, { direction: 'row' }, () => [
                h(Button, {
                    id: 'gridsizebtnA',
                    class: 'large',
                    onclick: () => set_grid_size_and_adjust_grid('A'),
                }, () => '-'),
                h(Button, {
                    id: 'gridsizebtnB',
                    class: 'large',
                    onclick: () => set_grid_size_and_adjust_grid('B'),
                }, () => '-'),
                h(Button, {
                    id: 'gridsizebtnC',
                    class: 'large',
                    onclick: () => set_grid_size_and_adjust_grid('C'),
                }, () => '-'),
                h(Button, {
                    id: 'gridsizebtnD',
                    class: 'large',
                    onclick: () => set_grid_size_and_adjust_grid('D'),
                }, () => '-'),
                h(Button, {
                    id: 'gridsizebtnE',
                    class: 'large',
                    onclick: () => set_grid_size_and_adjust_grid('E'),
                }, () => '-'),
            ]),

            h('div', { innerHTML: centered }),
        ]);
    }
});
